import { AuthGuard, CrudOp, targetAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredProjectParam, useRequiredSubprojectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { getTargetMaterialMode, importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const TargetManagerView: FC = () => {
  const brand = useRequiredProjectParam("brand");
  const tmmId = useRequiredSubprojectParam("tmmId");
  const targetMaterialMode = getTargetMaterialMode(brand);
  return (
    <AuthGuard authScope={targetAuthScope} crudOp={CrudOp.READ}>
      <Suspense><LazyTargetManagerView targetMaterialMode={targetMaterialMode} tmmId={tmmId}/></Suspense>
    </AuthGuard>
  );
};

const LazyTargetManagerView = lazy(importView(
  () => import("../components/TargetManagerView"),
  (it) => it.TargetManagerView,
));
